import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { translate } from '@/i18n/translate'
import {
  ACCEPTED_IMAGE_TYPES,
  MAX_FILE_SIZE,
  MAX_FILE_SIZE_IN_MB,
} from '@/lib/constants'

export const projectsCreateSteps = z.union([z.literal(1), z.literal(2)])
export type ProjectsCreateSteps = z.infer<typeof projectsCreateSteps>

export const projectsCreateSchema = z.object({
  currentStep: projectsCreateSteps,
  picture: z
    .union([
      z
        .custom<File>()
        .refine((file) => file instanceof File, {
          message: translate('common.validations.requiredValue'),
        })
        .refine((file) => file instanceof File && file.size <= MAX_FILE_SIZE, {
          message: translate('common.validations.files.fileTooLarge', {
            size: MAX_FILE_SIZE_IN_MB,
          }),
        })
        .refine(
          (file) =>
            file instanceof File && ACCEPTED_IMAGE_TYPES.includes(file.type),
          {
            message: translate(
              'common.validations.files.invalidImageType.description',
            ),
          },
        ),
      z.literal(''),
    ])
    .nullish(),
  name: z.string().min(1, translate('common.validations.requiredValue')),
  botIds: z.array(z.string()),
})

export type ProjectsCreateSchemaType = z.infer<typeof projectsCreateSchema>

export type ProjectsCreateFields = keyof ProjectsCreateSchemaType

export type ProjectsCreateSchemaMethods =
  UseFormReturn<ProjectsCreateSchemaType>

export interface HandleChangeFormStepProps {
  changeFormStep: 1 | -1
  formMethods: ProjectsCreateSchemaMethods
}
